export const defaultExceptionMessage = 'Something went wrong. Please contact support.';
export const resolveErrorMessage = 'Error resolving formula';
export const parseErrorMessage = 'Error while parsing formula';
export const previewErrorMessage = 'Error while previewing formula';
export const saveErrorMessage = 'Error while saving formula';
export const getFormulaErrorMessage = 'Error loading formula';
export const fetchDimensionsErrorMessage = 'Error while getting formula dimensions';
export const fetchFormulasErrorMessage = 'Error getting formulas';
